import React from "react";
import styles from '../LinkPersonalizado9/linkPersonalizado9.module.scss';

interface LinkPersonalizado9Props {
    href: string;
    title: string;
    colorText: string;
}

const LinkPersonalizado9: React.FC<LinkPersonalizado9Props> = ({
    href,
    title,
    colorText,
}) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            style={{
                color: colorText,
            }}
            className={styles.buttonLink}
        >
            {title}
        </a>
    );
};

export default LinkPersonalizado9;
